import $ from 'jquery';
import { debounce } from 'lodash';

let $body = $( 'body' );
let $header = $( '.header' );

function checkScroll () {
	if ( $( 'body' ).hasClass( 'has-onscroll-header' ) ) {
		if ( $( window ).scrollTop() > 180 ) {
			$body.addClass( 'has-fixed-header' );
			$header.addClass( 'header--fixed' );
		} else {
			$body.removeClass( 'has-fixed-header' );
			$header.removeClass( 'header--fixed' );
		}
	}
}

$( window ).scroll( debounce( checkScroll, 150 ) );
